import React from 'react'
import classnames from 'classnames'

import {SlotCard} from '../../../ui/cards/SlotCard'
import {Accordion, AccordionItem} from '../../../ui/components'
import {TExtraBlock} from '../../types'
import {LinkList} from '../LinkList'

import styles from './styles.module.css'

type TExtraBlockProps = TExtraBlock & {
  className?: string
}

export function ExtraBlock({title, items, className}: TExtraBlockProps) {
  return (
    <SlotCard className={classnames(styles.extraBlockContainer, className)}>
      <Accordion stretchToFillContainer>
        <AccordionItem
          header={title}
          headerKind="body"
          headerTag="span"
          className={styles.extraBlockContainer}
          headerClassName={styles.extraBlockHeader}
          descriptionCN={styles.extraBlockDescription}
        >
          <LinkList items={items} withDivider={false} className={styles.linkList} />
        </AccordionItem>
      </Accordion>
    </SlotCard>
  )
}
